import { register } from 'register-service-worker'
import { server } from 'config'
import { Logger } from '@vue-storefront/core/lib/logger'
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

if (process.env.NODE_ENV === 'production' || server.devServiceWorker) {
  register(`/service-worker.js`, {
    ready () {
      Logger.log('App is being served from cache by a service worker.')()
    },
    cached () {
      Logger.log('Content has been cached for offline use.')()
    },
    updated (registration) {
      Logger.log('New content is available, please refresh.')()
      // Let the app decide how to surface this (see App.vue). We pass the
      // registration so the UI can activate the waiting worker on demand.
      EventBus.$emit('application-after-sw-updated', registration)
    },
    offline () {
      Logger.log('No internet connection found. App is running in offline mode.')()
    },
    error (error) {
      Logger.error('Error during service worker registration:', error)()
    }
  })

  // When the waiting worker calls skipWaiting() it becomes the active controller,
  // firing `controllerchange`. Reload once so the page runs the new assets.
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true
      window.location.reload()
    })
  }
}
